import React, { useEffect, useState } from "react";
import "./sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import AnalyticsIconActive from "../../../assets/analyticsIconActive";
import DashboardSVG from "../../../assets/icons/sidebar/dashboardSVG";
import DistributorSvg from "../../../assets/icons/sidebar/distributorSvg";
import CustomersSvg from "../../../assets/icons/sidebar/customersSvg";
import SuperUserSvg from "../../../assets/icons/sidebar/superUserSvg";
import arrRig from "../../../assets/icons/sidebar/arrow-right-line.svg";
import { logout } from "../../../redux/actions/authActions";
import LogoutModal from "../../modals/logoutModal";
import SidebarComponent from "./sidebarComponent";
import SidebarIconComponent from "./sidebarIconComponent";
import InvoiceVerifySvg from "../../../assets/icons/sidebar/invoiceVerifySvg";
import SupportSvg from "../../../assets/icons/sidebar/supportSvg";
import SettingsSvg from "../../../assets/icons/sidebar/settingsSvg";
import ffuserSvg from "../../../assets/icons/sidebar/ffuserSvg";
import DivisionIcon from "../../../assets/icons/sidebar/divisionIcon";
import PoSvg from "../../../assets/icons/sidebar/poSvg";
import CrownSvg from "../../../assets/icons/sidebar/crownSvg";
import ManageOrdersvg from "../../../assets/icons/sidebar/manage-order-svg";
import CfaSvg from "../../../assets/icons/sidebar/cfaSvg";
import { analyticsStatusAction } from "../../../redux/actions/analyticsActions";
import { socket } from "../../../redux/config";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";

const SideBar = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const [logoutShow, setLogoutShow] = useState(false);
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [userPermissionList, setUserPermissionList] = useState(null); // PERMISSION START
  const [isAnalytics, setIsAnalytics] = useState(false);
  const user_type = localStorage.getItem("userType");
  const is_subscribed = localStorage.getItem("is_subscribed");

  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      console.log(
        permissionData?.map((item) => item?.module_name),
        "permission"
      );

      setUserPermissionList(permissionData?.map((item) => item?.module_name));
    }
  }, [user_type]); // PERMISSION END

  useEffect(() => {
    dispatch(analyticsStatusAction(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    console.log("checker", data?.data?.data);
    setIsAnalytics(data?.data?.data?.is_analytics);
  };
  const onError = (err) => {
    console.log(err);
  };

  useEffect(() => {
    socket.on("analytics_checker", (checker) => {
      console.log("checker", checker);
      setIsAnalytics(checker?.is_analytics);
    });
    return () => {
      socket.off("analytics_checker");
    };
  }, []);

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/");
  };

  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const location = useLocation();
  const url = location.pathname;
  const pathArray = url.split("/");
  const activePath = "/" + pathArray[1];

  const sidebarConfig = [
    {
      label: "Dashboard",
      path: "/dashboard",
      icon: DashboardSVG,
      visible: () => true,
    },
    {
      label: "Analytics",
      path: "/analytics",
      icon: AnalyticsIconActive,
      visible: () => isAnalytics && user_type !== "super_admin",
    },
    {
      label: "Field Force",
      path: "/field-force",
      icon: ffuserSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" ||
        userPermissionList.includes("Manufacturer"),

      subItems: [
        {
          label: "Admin",
          path: "/field-force/admin/view",
        },
        {
          label: "Head quarters",
          path: "/field-force/head-quarter",
        },
        {
          label: "designation",
          path: "/field-force/designation",
        },
        {
          label: "Users",
          path: "/field-force/user",
        },
      ],
    },
    {
      label: "Division",
      path: "/division",
      icon: DivisionIcon,
      visible: () => true,
    },
    {
      label: "Products",
      path: "/product",
      icon: CrownSvg,
      visible: () => true,
    },
    {
      label: "MANAGE ORDERS",
      path: "/manage-order",
      icon: ManageOrdersvg,
      visible: () => true,
    },
    {
      label: "Distributors",
      path: "/distributors",
      icon: DistributorSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" ||
        userPermissionList.includes("Distributors"),

      subItems: [
        {
          label: "ONBOARDED distributors",
          path: "/distributors/onboarded",
        },
        {
          label: "ONBOARDING distributors",
          path: "/distributors/onboarding",
        },
      ],
    },
    {
      label: "Customers",
      path: "/customers",
      icon: CustomersSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Customers"),

      subItems: [
        {
          label: "onboarded Doctors",
          path: "/customers/onboarded-doctors",
        },
        {
          label: "onboarded pharmacy",
          path: "/customers/onboarded-pharmacy",
        },
        {
          label: "onboarding doctor",
          path: "/customers/onboarding-doctor",
        },
        {
          label: "onboarding pharmacy",
          path: "/customers/onboarding-pharmacy",
        },
        {
          label: "Doctor Product Offers",
          path: "/customers/product-offer-request",
        },
        {
          label: "Pharmacy Product Offers",
          path: "/customers/pharmacy-product-offer-request",
        },
        {
          label: "subscribe requests",
          path: "/customers/subscribe-request",
        },
      ],
    },
    {
      label: "SUPER USERS",
      path: "/super-user",
      icon: SuperUserSvg,
      visible: () => localStorage.getItem("userType") !== "super_admin",

      subItems: [
        {
          label: "users",
          path: "/super-user/user",
        },
        {
          label: "roles",
          path: "/super-user/role",
        },
      ],
    },
    {
      label: "cfa",
      path: "/cfa",
      icon: CfaSvg,
      visible: () => true,
    },
    {
      label: "Purchase ORDER",
      path: "/purchase-order",
      icon: PoSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        is_subscribed == "false" &&
        (user_type !== "super_admin" ||
          userPermissionList.includes("Invoice verification")),
    },
    {
      label: "invoice verification",
      path: "/invoice-verification",
      icon: InvoiceVerifySvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        is_subscribed == "false" &&
        (user_type !== "super_admin" ||
          userPermissionList.includes("Invoice verification")),

      subItems: [
        {
          label: "Ai Verified Invoices",
          path: "/invoice-verification/ai-verified-invoices",
        },
        {
          label: "Verified Invoices",
          path: "/invoice-verification/verified-invoices",
        },
        {
          label: "Ai Flaged Invoices",
          path: "/invoice-verification/ai-flagged-invoices",
        },
        {
          label: "Pending Invoices",
          path: "/invoice-verification/pending-invoices",
        },
        {
          label: "Rejected Invoices",
          path: "/invoice-verification/rejected-invoices",
        },
      ],
    },
    {
      label: "Support",
      path: "/support",
      icon: SupportSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        is_subscribed == "false" &&
        (user_type !== "super_admin" || userPermissionList.includes("Support")),

      subItems: [
        {
          label: "Customer Verification",
          path: "/support/customer-verification",
        },
      ],
    },
    {
      label: "Settings",
      path: "/settings",
      icon: SettingsSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Settings"),
    },
  ];

  return (
    <>
      <div
        className={`${
          open
            ? "d-block mainlayout_sidebar_small_display"
            : "mainlayout_sidebar_display d-none d-lg-block"
        }   position-relative`}
      >
        <div className="d-none d-lg-block" onClick={() => setOpen(!open)}>
          <div className="position-absolute arrow-container py-2 cursor_pointer">
            <div className={open ? "arrow-open-icon" : "arrow-icon me-1"}>
              <img src={arrRig} alt={"right"} />
            </div>
          </div>
        </div>
        {open ? (
          <SidebarIconComponent
            userPermissionList={userPermissionList}
            sidebarConfig={sidebarConfig}
          />
        ) : (
          <div
            className="h-100"
            style={{ maxWidth: "295px", overflow: "hidden" }}
          >
            <SidebarComponent
              open={open}
              setOpen={setOpen}
              userPermissionList={userPermissionList}
              sidebarConfig={sidebarConfig}
            />
          </div>
        )}
      </div>

      <LogoutModal
        logoutShow={logoutShow}
        handleLogoutClose={() => setLogoutShow(false)}
        logoutFunc={logoutHandler}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default SideBar;
